<template>
  <div class='block-main-media block-main-media-video'>
    <a v-if='showLink' :href='imageLink' class='video-play-button'>
        <top-image-box-content :is-active='true' :isCanceled='canceledHearing' :isPostponed='postponedHearing' ></top-image-box-content>
    </a>
    <div v-else class='no-link'>
        <top-image-box-content :is-active='false' :isCanceled='canceledHearing' :isPostponed='postponedHearing' ></top-image-box-content>
    </div>
  </div>
</template>

<script>
import TopImageBoxContent from './TopImageBoxContent'
import mixins from '../../mixins'

export default {
  mixins: [mixins],
  name: 'top-image-box',
  data () {
    return {
      imageLink: this.$root.cmsData.mainBlock.imageLink
    }
  },
  components: {
    TopImageBoxContent
  },
  computed: {
    showLink: function () {
      return this.liveHelper().shouldShowImageLink(this.$root.cmsData, this.$root.liveData)
    },
    canceledHearing: function () {
      return this.liveHelper().canceledHearing(this.$root.cmsData, this.$root.liveData)
    },
    postponedHearing: function () {
      return this.liveHelper().postponedHearing(this.$root.cmsData, this.$root.liveData)
    }
  }
}
</script>



// WEBPACK FOOTER //
// TopImageBox.vue?7fe6494e